import { api } from "@/api/client";
import type { components } from "@/api/contract";
import { unwrap } from "@/api/errors";

export type ModelListResponse = components["schemas"]["ModelListResponse"];

/** GET /v1/chat/models — the catalog is small, so one wide page is enough. */
export async function listModels(): Promise<ModelListResponse> {
  return unwrap(await api.GET("/v1/chat/models", { params: { query: { limit: 100 } } }));
}
